var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6758 21H7.67578C3.67578 21 2.67578 20 2.67578 16V8C2.67578 4 3.67578 3 7.67578 3H17.6758C21.6758 3 22.6758 4 22.6758 8V16C22.6758 20 21.6758 21 17.6758 21Z",
    stroke: "#0D4740",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6758 8H19.6758",
    stroke: "#0D4740",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6758 12H19.6758",
    stroke: "#0D4740",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6758 16H19.6758",
    stroke: "#0D4740",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17523 11.2919C10.1749 11.2919 10.9852 10.4815 10.9852 9.48187C10.9852 8.48224 10.1749 7.67188 9.17523 7.67188C8.1756 7.67188 7.36523 8.48224 7.36523 9.48187C7.36523 10.4815 8.1756 11.2919 9.17523 11.2919Z",
    stroke: "#0D4740",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6758 16.3317C12.5358 14.8817 11.3858 13.7417 9.93578 13.6117C9.43578 13.5617 8.92578 13.5617 8.41578 13.6117C6.96578 13.7517 5.81578 14.8817 5.67578 16.3317",
    stroke: "#0D4740",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.1754d7ca75ed571edbb1930a4f0140e9.svg";
export { ForwardRef as ReactComponent };